import React from "react";
import Select from "react-select";
import usStateOptions from "./usStateOptions";

// Selectable states, without the blank option used by the single select
const options = usStateOptions.filter((option) => option.value !== "");

export const sortStates = (states) => (states || []).slice().sort();

const UsStateMultiSelect = ({ values, onValuesChanged, placeholder = "States..." }) => {
  const selected = sortStates(values).map((state) => ({ value: state, label: state }));

  return (
    <Select
      options={options}
      value={selected}
      onChange={(newValues) => onValuesChanged(sortStates((newValues || []).map((option) => option.value)))}
      isMulti
      isSearchable
      isClearable
      placeholder={placeholder}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary50: '#DEF2F1',
          primary25: '#DEF2F1',
          primary: '#3AAFA9',
        },
      })}
    />
  );
};

export default UsStateMultiSelect;
